export default { title: 'Upload Google-anmeldelse' };
